import React from "react";

export default (props) => (
    <i className={`sprite sprite-i-video-default-selected`} />
);
